import React from "react";
import { Row, Col, Button } from "antd";

const JuryAbout = (props) => {
  return (
    <div id="aboutJury">
      <Row gutter={[16, 16]} align='middle' style={{ margin: '0' }}>
        <Col xs={24} md={12}>
          <div className="ctapagecontent">
            <h2 style={{ textAlign: 'left' }}>The Stage will be Set for The Jury 4.0 at Flipkart Connect</h2>
            <p>Every year, the campaigns you’ve created with Flipkart Ads have raised the bar of innovation, sparked creativity, and achieved remarkable results worth celebrating. Now, it’s time to celebrate your Ad excellence!</p>
            <p>
              The Jury 4.0 is the chance to shine, as the industry’s finest minds come together to recognise and reward ad-brilliance. So, gear up, take pride, and let us celebrate the innovative spirit that makes you stand out!
            </p>
            <div style={{ textAlign: 'left' }}>
              <Button className="meetjurybtn" type="primary" target="_blank" href="/jury">Know More</Button>
            </div>
          </div>

          {/* <div className="ctapagecontent">
            <Button className="meetjurybtn" type="primary" target="_blank" href="https://flipkartconnectjuryawards.com/">Know More</Button>
          </div> */}
        </Col>
        <Col xs={24} md={12}>
          <div className="about-text">

            <video
              autoPlay muted loop playsInline
              className="jurysidevideo"
            >
              <source src="https://storage.googleapis.com/wiz365/1db9f138-f036-11ef-bbe9-bfb0b1ca96e2.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default JuryAbout;
